import type { Lottie } from '../types/lottie';

export abstract class BasePlugin {
    abstract update(json: Lottie): void;
}
